"use client";

import React from "react";

//Styles
import * as S from "./styles";

//Type
import { StatusProps } from "@/types";

const Status: React.FC<StatusProps> = ({ className, type, statusText }) => {
  return (
    <S.BoxStatus className={className} $type={type}>
      {statusText}
    </S.BoxStatus>
  );
};

export default Status;
